import React from 'react';
import type { MenuItem } from '../../../shared/config/menuVoteData';
import { Card, Image, ImageWrap, Name, Placeholder } from './MenuCard.styles';

export interface MenuCardProps {
  item: MenuItem;
  /** 활성(중앙) 카드 여부 — 크기/불투명도/그림자/배지 차이 (§1-3) */
  active: boolean;
}

/**
 * 메뉴 카드 (entity)
 * - 활성: 크게/흰 배경 100%/그림자/정답 배지/검정 텍스트
 * - 비활성: 작게/흰 배경 15% glass/회색 텍스트
 * 출처: spec §1-3, §2
 */
export function MenuCard({ item, active }: MenuCardProps) {
  return (
    <Card $active={active}>
      <ImageWrap>
        {item.isPlaceholder || !item.image ? (
          // 콘텐츠 미확보 placeholder (§6-1)
          <Placeholder aria-hidden="true">메뉴 사진 자리</Placeholder>
        ) : (
          <Image
            src={item.image}
            alt={`${item.name} 사진`}
            width={item.imageSize?.width}
            height={item.imageSize?.height}
            loading="lazy"
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
          />
        )}
      </ImageWrap>

      <Name $active={active}>{item.name}</Name>
    </Card>
  );
}
